import { v4 as uuid } from "uuid";

export class CompanyId {
  readonly value: string;
  constructor(value: string) {
    this.value = value;
  }

  toString(): string {
    return this.value;
  }

  static random(): CompanyId {
    return new CompanyId(uuid());
  }
}
